import { useTranslation } from "react-i18next";

import Modal from "./Modal";
import CustomButton from "./CustomButton";
import Loader from "./Loader";
import ErrorBox from "./ErrorBox";

export default function AreYouSureModal({
  shouldCloseModal,
  onClose,
  onConfirm,
  customMessage,
  closeTitle,
  confirmTitle,
  loading,
  confirm,
  confirmButtonVariant,
  confirmIconType = "delete",
  modalSize,
  error,
}) {
  const { t } = useTranslation("general");

  const message = customMessage || "areYouSureDefaultMessage";

  if (shouldCloseModal) {
    onConfirm();
    return null;
  }

  const buttonVariant =
    confirmButtonVariant !== undefined
      ? confirmButtonVariant
      : confirm
        ? ""
        : "red";

  // ✅ SWITCH CASE ICON HANDLER
  const getConfirmIcon = () => {
    switch (confirmIconType) {
      case "save":
        return "save";
      case "close":
        return "close";
      case "whiteCheck":
        return "whiteCheck";
      case "logout":
        return "logout";
      case "delete":
      default:
        return "delete";
    }
  };

  return (
    <Modal
      title="areYouSureModalTitle"
      onClose={onClose}
      modalSize={modalSize || "c-modal--x-small"}
      error={error}
      footer={
        <>
          {loading && <Loader />}

          <section className="edit-user-actions">
            <CustomButton
              title={t(confirmTitle || "yesClose")}
              onClick={onConfirm}
              variant={buttonVariant}
              icon={getConfirmIcon()}
              iconSize={16}
              disabled={loading}
            />

            <CustomButton
              title={t(closeTitle || "noStay")}
              onClick={onClose}
              variant="blank"
              icon="close"
              iconSize={14}
            />
          </section>
        </>
      }
    >
      {error && <ErrorBox>{error}</ErrorBox>}
      <p>{t(message)}</p>
    </Modal>
  );
}
